// extracted by mini-css-extract-plugin
export default {"closeIcon":"ModalGeneric_closeIcon__34uT-","modal":"ModalGeneric_modal__rrYbm"};